import { Button, Card, CardContent, Stack, Typography } from '@mui/material'
import React from 'react'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import { useMutation } from 'react-query'
import { AxiosResponse } from 'axios'
import PyAPI from '../../../APIs/Python/APIs/PyAPI'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../../garvan-react/Components/ModalFeedback/MessagePopup'
import {
  useBarcodePayload,
  useContainerPayload,
  useVesselPayload,
} from '../useBarcodePayload'
import StepHeader from './StepHeader'
import { stackGap } from '../../../Constants&Theme/Spacing'

function Step4Process() {
  const {
    containerSelectionModel,
    vesselSelectionModel,
    selectedFunc,
    setOpenClear,
    setConfirmClear,
    setBarcodes,
    mutateBarcodes,
  } = useReaderContext()
  const { whoAmI } = useUserContext()
  const { setError, setMessage } = useMessagePopupContext()
  const containerPayload = useContainerPayload()
  const vesselPayload = useVesselPayload()
  const barcodePayload = useBarcodePayload()

  const changeMutation = useMutation<any, AxiosResponse>({
    mutationFn: () =>
      PyAPI.post(whoAmI!, '/reader/update_change_dates', containerPayload),
    onError: (err) => setError(err),
    onSuccess: (data) => {
      setOpenClear(true)
      setConfirmClear(true)
      setMessage({ subject: 'Success', message: data, severity: 'success' })
      setBarcodes({})
      mutateBarcodes.reset()
    },
  })

  const transitMutation = useMutation<any, AxiosResponse>({
    mutationFn: () => PyAPI.post(whoAmI!, '/reader/transit', containerPayload),
    onError: (err) => setError(err),
    onSuccess: (data) => {
      setMessage({ subject: 'Success', message: data, severity: 'success' })
      setBarcodes({})
      mutateBarcodes.reset()
    },
  })

  const confirmVesselsMutation = useMutation<any, AxiosResponse>({
    mutationFn: () =>
      PyAPI.post(whoAmI!, '/reader/confirm_vessels', vesselPayload),
    onError: (err) => setError(err),
    onSuccess: (data) => {
      setMessage({ subject: 'Success', message: data, severity: 'success' })
      setBarcodes({})
      mutateBarcodes.reset()
    },
  })

  const confirmShipmentMutation = useMutation<any, AxiosResponse>({
    mutationFn: () =>
      PyAPI.post(whoAmI!, '/reader/confirm_shipment', barcodePayload),
    onError: (err) => {
      console.warn(err)
      setError(err)
    },
    onSuccess: (data) => {
      setMessage({ subject: 'Success', message: data, severity: 'success' })
      setBarcodes({})
      mutateBarcodes.reset()
    },
  })
  return (
    <Card
      variant="outlined"
      sx={{ flex: 1 }}
    >
      <CardContent>
        <StepHeader
          step={4}
          name={'Process'}
        />
        <Stack gap={stackGap.col}>
          <Typography variant="body2">Apply and save the changes</Typography>
          <Button
            variant={'outlined'}
            disabled={
              containerSelectionModel.length + vesselSelectionModel.length ===
                0 || !selectedFunc
            }
            onClick={() => {
              switch (parseInt(selectedFunc!)) {
                case 3:
                  changeMutation.mutate()
                  break
                case 10:
                  transitMutation.mutate()
                  break
                case 15:
                  confirmVesselsMutation.mutate()
                  break
                case 6:
                  confirmShipmentMutation.mutate()
                  break
                default:
                  console.log('No function selected')
              }
              //   TODO: Clear selection and DG on success
            }}
          >
            Process
          </Button>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Step4Process
